import { useState, createContext, useMemo, useCallback } from 'react'
import { Backdrop, Paper } from '@mui/material'
import LayoutTitle from './layout-single-action/BreadCrumb'

export const LayoutContext = createContext({})

function LayoutSingleAction(_props) {
  const {
    fullscreen = true,
    breadCrumb = null,
    title = "",
    parentRouteName = null, // injected by route builder
    children,
    intialState = {},
  } = _props

  const [layoutState, setLayoutState] = useState({
    isFullscreen: fullscreen,
    breadCrumb,
    parentRouteName,
    title,
    ...intialState,
  })

  const setLayoutContext = (newState) => {
    setLayoutState({ ...layoutState, ...newState })
  }

  const handleToggleFullscreen = () => {
    setLayoutContext({ isFullscreen: !layoutState.isFullscreen})
  }

  const HideWhenNotFullscreen = ({ children }) => {
    return layoutState.isFullscreen ? children : null
  }

  const memoizedChildren = useMemo(() => children, [])

  const Content = useCallback(() => {
    return layoutState.isFullscreen ? (
      <Paper square className="fixed inset-0 overflow-y-auto overflow-x-hidden">
        <LayoutTitle
        />
        <div className="bg-bg px-8 pt-32 pb-8 min-h-screen">{memoizedChildren}</div>
      </Paper>
    ) : (
      <Paper
        elevation={6}
        className="fixed w-[80vw] max-w-[60rem] h-auto max-h-[75vh] overflow-hidden top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <LayoutTitle
        />
        <div className="bg-bg px-8 pt-8 pb-8 max-h-[66vh] overflow-auto">{memoizedChildren}</div>
      </Paper>
    )
  },[layoutState.isFullscreen])

  return (
    <Backdrop open={true}>
      <LayoutContext.Provider
        value={{
          handleToggleFullscreen,
          layoutState,
          setLayoutContext,
          HideWhenNotFullscreen
        }}
      >
        <Content/>
      </LayoutContext.Provider>
    </Backdrop>
  )
}

export default LayoutSingleAction
